<template>
  <div :class="[containerClass]">
    <label v-if="label" :id="`input-${name}-label`" :for="`input${name}`" :class="[labelClass || 'form-label fs-6 fw-bolder text-black', {isRequired: 'required'}]">
      {{ label }} <span v-if="isRequired" class="text-danger"> * </span>
    </label>
    <vue-tel-input required
                   :key="`input-${name}-key-${componentKey}`"
                   :validCharactersOnly="true"
                   :inputOptions="options"
                   :defaultCountry='defaultCountry'
                   :dropdownOptions="dropdownOptions"
                   @on-input="thirstInputChanged"
                   :autoDefaultCountry="true"
                   :id="`input-tel-name`"
                   :disabled="isDisabled"
                   styleClasses="form-control form-control-lg form-control-solid p-1 rounded"
                   name="input-phone"
                   v-model="telPhone">
    </vue-tel-input>
  </div>
</template>

<script setup>
import { VueTelInput } from 'vue-tel-input'
import 'vue-tel-input/dist/vue-tel-input.css';
import {computed, defineProps, defineEmits, ref, onMounted, watch, onUpdated, nextTick} from "vue";

const props = defineProps({
  phone: String,
  phoneCode: String,
  inputClass: String,
  name: String,
  placeholder: String,
  isRequired: Boolean,
  labelClass: String,
  containerClass: {
    type: String,
    default: 'col-12 mb-10'
  },
  label: String,
  isDisabled: Boolean,
})

const emits = defineEmits(['update:phone', "update:phoneCode"])

const options = computed(() => {
  return {
    placeholder: props.placeholder,
    showDialCode : false,
    styleClasses: 'rounded form-control-solid'
  }
})

const dropdownOptions = ref({
  showDialCodeInSelection: true,
  showDialCodeInList: true,
  showFlags: true
})

const defaultCountry = computed(() => props.phoneCode && props.phone ? Number(props.phoneCode.replace('+', '')) : 229)

const telPhone = ref(props.phone || '')
const componentKey = ref(0);

// Vrai uniquement pendant l'émission déclenchée par la saisie de
// l'utilisateur (thirstInputChanged) — sert à distinguer un changement de
// phoneCode "externe" (ex: préremplissage à l'édition, doit forcer un
// remount de vue-tel-input car son defaultCountry n'est pas réactif après
// le montage) d'un simple écho de ce que le composant vient lui-même
// d'émettre en tapant. Sans cette garde, chaque frappe fait remonter
// vue-tel-input en plein événement input, ce qui casse sa ref interne
// ("Cannot read properties of null (reading 'setCustomValidity')").
let isInternalUpdate = false

watch(() => props.phone, (val) => {
  telPhone.value = val || ''
})

watch(() => props.phoneCode, (val) => {
  if (isInternalUpdate) return
  if(val) {
    dropdownOptions.value.showFlags = false
    componentKey.value = Number(val.replace('+', ''))
  }
  dropdownOptions.value.showFlags = true
})


const thirstInputChanged = (number, phoneObject) => {
  if (phoneObject) {
    isInternalUpdate = true
    emits("update:phone", phoneObject.formatted);
    emits("update:phoneCode", '+' + phoneObject.countryCallingCode);
    nextTick(() => { isInternalUpdate = false })
  }
}

</script>

<style scoped>
input.invalid {
  border: 1px solid red;
}

div.vti__dropdown {
  padding: 0 !important;
}

</style>
